import { createModule } from '../actions/utils';
import { SERVICE_ENDPOINT } from '../apis/constants';

const GetShopifyErrors = createModule({
  base: 'GET_SHOPIFY_ERRORS', apiDetails: SERVICE_ENDPOINT.GET_SHOPIFY_ERRORS,
});

export { GetShopifyErrors };
